import { Box } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { EntityType } from "@common/Common.types";
import { useTranslation } from "@localization/useTranslation";
import EntityGraphDialog from "@common/components/entityGraph/EntityGraphDialog";
import GraphSegmentedControl from "@common/components/entityGraph/GraphSegmentedControl";
import { useEntityGraphStyles } from "@common/components/entityGraph/EntityGraph.styles";
import { useRiskEntityGraphDialog } from "./RiskEntityGraphDialog.hooks";
import { buildRiskOverlay } from "./riskEntityGraphOverlay";

export interface RiskEntityGraphDialogProps {
    rootType: EntityType;
    rootId: string;
    riskAreaId: string;
    onClose: () => void;
}

// The risk-module entry to the entity graph: same dialog, but scores fetched for a risk area (switchable when
// the customer has several) and the risk overlay decorating the nodes.
function RiskEntityGraphDialog(props: RiskEntityGraphDialogProps) {
    const { selectedRiskAreaId, onRiskAreaChange, areaOptions, showAreaSwitcher } = useRiskEntityGraphDialog(props.riskAreaId);
    const styles = useEntityGraphStyles();
    const { translateString } = useTranslation();

    return (
        <EntityGraphDialog
            rootType={props.rootType}
            rootId={props.rootId}
            onClose={props.onClose}
            riskAreaId={selectedRiskAreaId}
            topContent={
                showAreaSwitcher ? (
                    <Box sx={styles.toolbarGroup}>
                        <DotLegalHeader headerStyle="medium" marginBottom={0}>
                            {translateString("riskArea")}:
                        </DotLegalHeader>
                        <GraphSegmentedControl options={areaOptions} selected={selectedRiskAreaId} onSelect={onRiskAreaChange} />
                    </Box>
                ) : undefined
            }
            overlayFactory={(risk) => buildRiskOverlay(risk, translateString)}
        />
    );
}

export default RiskEntityGraphDialog;
